import React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { OpeningHourHistoryDetails } from './OpeningHourHistoryDetails';

export const OpeningHourHistoryGrid = ({ history, selected, setSelected }) => {

  const rows = history.map((record, id) => ({
    ...record,
    id,
  }));

  const columns = [
    { field: 'modified_by', headerName: 'Updated By', flex: 1 },
    {
      field: 'modified_at',
      headerName: 'Updated On',
      type: 'date',
      flex: 1.2,
      renderCell: (params) =>
        format(parseISO(params.value), 'd MMM yyyy, HH:mm:ss'),
    },
    { field: 'type', headerName: 'Type', flex: 0.8 },
  ];

  const sortModel = [
    {
      field: 'modified_at',
      sort: 'desc',
    },
  ];

  const showHistoryDetails = selected !== null;
  if (showHistoryDetails) {
    return <OpeningHourHistoryDetails details={history[selected]} setSelected={setSelected} />;
  }

  return (
    <DataGrid
      rows={rows}
      columns={columns}
      sortModel={sortModel}
      onRowSelected={({ data }) => setSelected(data.id)}
    />
  );
};
